export default "__VITE_ASSET__CPoeaWcd__"